import Webcam from "react-webcam"
import { useRef, useCallback } from "react"

const CameraModal = ({
  onCapture,
  onClose,
}: {
  onCapture: (imageSrc: string) => void
  onClose: () => void
}) => {
  const webcamRef = useRef<Webcam>(null)

  const capture = useCallback(() => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot()
      if (imageSrc) {
        onCapture(imageSrc)
        onClose()
      }
    }
  }, [webcamRef, onCapture, onClose])

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Take Photo</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body text-center">
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={{ facingMode: { ideal: "environment" }, aspectRatio: 1 }}
              className="img-fluid mb-3"
            />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light border border-light me-2"
              onClick={onClose}
            >
              Cancel
            </button>
            <button type="button" className="btn btn-primary" onClick={capture}>
              Capture Photo
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CameraModal
